import clsx from 'clsx';
import React from 'react'
import styled, { css } from 'styled-components';

export const IconPlus = ({onClick, className}) => {
  return (
    <PlusIcon
      className={clsx('plus-icon', className)}
     {...(onClick ? { onClick } : {})}
    />
  )
}

const PlusIcon = styled.div`
${({ theme }) => css`
  &.plus-icon {
          top: 50%;
          transform: translateY(-50%);
          right: 23px;
          position: absolute;
          padding: 10px;
          transition: 0.3s ease all;

          &:before{
            content: '';
            width: 100%;
            height: 2px;
            display: block;
            background-color: #000;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
             transition: 0.3s ease all;

          }

          &:after{
            content: '';
            height: 100%;
            width: 2px;
            display: block;
            background-color: #000;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
             transition: 0.3s ease all;
          }
        }
`}
`;